define('default-resource',['i18n-provider', 'app-route-provider', 'notify-service'], function() {
  var app = angular.module('default.resource', ['i18n.provider', 'app.route.provider', 'notify.service']);
  app.factory('Default', ['$q', '$http', '$location', 'i18n', 'appRoute', 'notify',
    function($q, $http, $location, i18n, appRoute, notify, $multipart) {
      return {
        getLayout:function () {//index de amostra
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('default.getLayout')).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                notify.addNotification(error.notifications);
              } else {
                notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', 'Error'));
              }
              reject(error);
            });
          });
        },
        checkLoginFacebook:function (data) {//index de amostra
          return $q(function (resolve, reject) {
            $http.post(appRoute.linkTo('default.checkLoginFacebook'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                notify.addNotification(error.notifications);
              } else {
                notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', 'Error'));
              }
              reject(error);
            });
          });
        },
        checkLogin:function (data) {//index de amostra
          return $q(function (resolve, reject) {
            $http.post(appRoute.linkTo('default.checkLogin'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                notify.addNotification(error.notifications);
              } else {
                notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', 'Error'));
              }
              reject(error);
            });
          });
        },
        logout:function (data) {//index de amostra
          return $q(function (resolve, reject) {
            $http.post(appRoute.linkTo('default.logout'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                notify.addNotification(error.notifications);
              } else {
                notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', 'Error'));
              }
              reject(error);
            });
          });
        },
        newCad:function (data) {//index de amostra
          return $q(function (resolve, reject) {
            $http.post(appRoute.linkTo('default.newCad'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                notify.addNotification(error.notifications);
              } else {
                notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', 'Error'));
              }
              reject(error);
            });
          });
        },
        resetPassword:function (data) {//index de amostra
          return $q(function (resolve, reject) {
            $http.post(appRoute.linkTo('default.resetPassword'), data).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                notify.addNotification(error.notifications);
              } else {
                notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', 'Error'));
              }
              reject(error);
            });
          });
        },
        getTipoCadastroFiltro: function(ttpr_codigo){
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('default.getTipoCadastroFiltro', {ttpr_codigo:ttpr_codigo})).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                notify.addNotification(error.notifications);
              } else {
                notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', 'Error'));
              }
              reject(error);
            });
          });
        },

        getBairro:function (cid_codigo, imo_bairro) {//index de amostra
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('default.getBairro', {'cid_codigo':cid_codigo, 'imo_bairro':imo_bairro})).success(function (data) {
              resolve(data);
            }).error(function (error) {
              if (error && error.notifications && !_.isEmpty(error.notifications)) {
                //notify.addNotification(error.notifications);
              } else {
                //notify.addNotification('danger', i18n.__('couldNotLoadFemaleRecords', i18n.__('imobiliariaLayout')));
              }
              reject(error);
            });
          });
        },

        reloadUsuarioLogado: function(){
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('default.reloadUsuarioLogado')).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        addImovelFavorito:function(obj){
          return $q(function (resolve, reject) {
            $http.post(appRoute.linkTo('default.addImovelFavorito'),obj).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        
        favoritarImovel:function(){
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('default.favoritarImovel')).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        favoritar:function(){
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('default.favoritar')).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        //esqueci minha senha
        checkToken:function(obj){
          return $q(function (resolve, reject) {
            return $http.post(appRoute.linkTo('default.resetAccount'), obj).success(function (response) {
              var data = (response.data) ? response.data : response;
              if (data && data.redirect) {
                appRoute.redirect(data.redirect);
              }
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        resetPasswordvalid:function(obj){
         return $q(function (resolve, reject) {
            return $http.post(appRoute.linkTo('default.resetPasswordValid'), obj).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        saveEmailNews:function(obj){
          return $q(function (resolve, reject) {
            $http.post(appRoute.linkTo('default.saveEmailNews'), obj).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        dataIndex: function() {
          return $q(function (resolve, reject) {
            $http.post(appRoute.linkTo('default.dataIndex')).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        },
        getTemplate: function() {
          return $q(function (resolve, reject) {
            $http.get(appRoute.linkTo('default.getTemplate')).success(function (data) {
              resolve(data);
            }).error(function (error) {
              reject(error);
            });
          });
        }
      }
    }]);
});

